import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { OrganizationLightInterface } from '@sport-activities/sdk';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { OrganizationService } from '~/core/services/organization/organization.service';

export const OrganizerResolver: ResolveFn<OrganizationLightInterface> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  router: Router = inject(Router),
  organizationService: OrganizationService = inject(OrganizationService)
): Observable<OrganizationLightInterface> => {
  return organizationService.getOrganizationById(route.paramMap.get('id')).pipe(
    catchError((error) => {
      router.navigateByUrl('/404');

      return throwError(() => error);
    })
  );
};
